import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Background';
import { styles } from './Background.styles';

const Background = withAnimation()(withStyles(styles)(withSounds()(Component)));

export { Background };

// Commit trace: 2025-10-27T00:55:04 - docs: update docstrings in index.js

// Commit trace: 2026-02-05T04:03:22 - refactor: reorganize imports in index.js

// Commit trace: 2026-03-20T17:22:07 - feat: add utility helper to index.js
